import { useFetch } from 'hooks/useFetch'
import { IndexResponseBody } from './type'

export const useFetchSchedules = (campaignId: string, isImmediate = false) => {
  const path = `api/v1/admin/campaigns/${campaignId}/schedules`
  return useFetch<IndexResponseBody>(path, isImmediate)
}
